import type { SimpleMarketplaceResponse } from '@yoop/data-access-model';

/**
 * Checks if a group of marketplaces contains at least one marketplace without a parent
 * @param marketplaces
 */
export const containsOrphanMarketplace: (marketplaces: SimpleMarketplaceResponse[]) => boolean = (
  marketplaces: SimpleMarketplaceResponse[],
) => marketplaces.some((marketplace) => !marketplace.parentMarketplaceId);
